import React from "react";
import { useParams } from "react-router-dom";

export default () => {
  const { type } = useParams();

  return (
    <div className="noPostAvailable">Unfortunately, this {type} not available.</div>
  );
};
